import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "file has-name" }
const _hoisted_2 = { class: "file-label" }
const _hoisted_3 = { class: "file-cta" }
const _hoisted_4 = { class: "file-icon" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "file-label" }, " Escolha um arquivo... ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _createElementVNode("input", {
        class: "file-input",
        type: "file",
        name: "file",
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFile && _ctx.handleFile(...args))),
        accept: "image/*"
      }, null, 32),
      _createElementVNode("span", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-upload" })
        ]),
        _hoisted_5
      ]),
      (_ctx.selectedFile != '')
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            ref: "fileName",
            class: "file-name"
          }, _toDisplayString(_ctx.selectedFile), 513))
        : _createCommentVNode("", true)
    ])
  ]))
}